import React, { FC, useLayoutEffect } from 'react'
import WelcomeLayout from '../../components/WelcomeLayout/WelcomeLayout'
import { Route } from 'react-router-dom'
import {
	PAGE_DASHBOARD,
	PAGE_LOGIN,
	PAGE_LOGIN_2FA_CODE,
	PAGE_LOGIN_2FA_METHOD,
	PAGE_LOGIN_2FA_PHONE,
	PAGE_LOGIN_FORGOT_PASSWORD,
	PAGE_LOGIN_TERMS,
	PAGE_PATIENTS,
} from '../../constants/navigation'
import LoginForm from './LoginForm/LoginForm'
import LoginForgotPasswordForm from './LoginForgotPassword/LoginForgotPasswordForm'
import Login2FAMethodForm from './Login2FA/Login2FAMethodForm'
import Login2FACodeForm from './Login2FA/Login2FACodeForm'
import Login2FAPhoneForm from './Login2FA/Login2FAPhoneForm'
import LoginTerms from './LoginTerms/LoginTerms'
import Error404 from '../../components/Error/Error404'
import { Switch, useHistory } from 'react-router'
import { useTypedSelector } from '../../hooks/useTypedSelector'
import { selectAuthStatus } from '../../store/reducers/auth/selectors'
import { AsyncFunction } from '../../types/common'
import { getUser } from '../../store/reducers/user/actions'
import { useDefaultComponentTools } from '../../hooks/useDefaultComponentTools'
import Box from '@mui/material/Box'
import { CircularProgress } from '@mui/material'
import { USER_ROLES } from '../../types/user'

const LoginPage: FC = () => {
	const isAuth = useTypedSelector(selectAuthStatus)
	const history = useHistory()
	const { loading, setLoading, dispatch, isMounted, alert } =
		useDefaultComponentTools()

	useLayoutEffect(() => {
		const getUserData: AsyncFunction = async () => {
			try {
				setLoading(true)

				const user = await dispatch(getUser())

				if (user && !user?.termsOfService?.approved) {
					history.replace(PAGE_LOGIN_TERMS)

					return
				}

				const redirectPath = user?.employment?.roles?.includes(
					USER_ROLES.ORG_ADMIN
				)
					? PAGE_PATIENTS
					: PAGE_DASHBOARD

				history.replace(redirectPath)
			} catch (e: any) {
				'message' in e && alert.error(e.message)
			} finally {
				isMounted() && setLoading(false)
			}
		}

		if (isAuth) {
			getUserData()
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isAuth, dispatch, isMounted])

	return (
		<>
			{loading && (
				<Box
					display={'flex'}
					alignItems={'center'}
					justifyContent={'center'}
					position={'fixed'}
					top={0}
					right={0}
					bottom={0}
					left={0}
				>
					<CircularProgress />
				</Box>
			)}

			{!loading && (
				<WelcomeLayout>
					<Switch>
						<Route
							exact
							path={`${PAGE_LOGIN}`}
							component={LoginForm}
						/>

						<Route
							exact
							path={`${PAGE_LOGIN_FORGOT_PASSWORD}`}
							component={LoginForgotPasswordForm}
						/>

						<Route
							exact
							path={`${PAGE_LOGIN_2FA_METHOD}`}
							component={Login2FAMethodForm}
						/>

						<Route
							exact
							path={`${PAGE_LOGIN_2FA_CODE}`}
							component={Login2FACodeForm}
						/>

						<Route
							exact
							path={`${PAGE_LOGIN_2FA_PHONE}`}
							component={Login2FAPhoneForm}
						/>

						<Route
							exact
							path={`${PAGE_LOGIN_TERMS}`}
							component={LoginTerms}
						/>

						<Route path={'*'} component={Error404} />
					</Switch>
				</WelcomeLayout>
			)}
		</>
	)
}

export default LoginPage
